export default function CapabilityNotice() {
  return <p className="admin-v2-fixture-notice" role="status">고정 데이터 · API 미연결</p>;
}
